import type { Media } from 'queries/graphql';

type ImgProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
  placeholder?: 'blur';
  blurDataURL?: string;
};

export function buildImgProps(media: Media | null | undefined): ImgProps {
  if (!media || !media.src) {
    // No usable media — caller should guard the surrounding render so
    // we don't emit `<Image src="">` (which renders a broken icon in
    // Next 15). Return zero dimensions to make the empty-state obvious
    // if a caller forgets the guard, and to preserve the prior return
    // shape for type-stability.
    return {
      src: '',
      alt: '',
      width: 0,
      height: 0,
    };
  }

  const payload: ImgProps = {
    src: media.src,
    alt: media.alt || '',
    width: media.width || 0,
    height: media.height || 0,
  };

  if (media.blurDataUrl) {
    payload.placeholder = 'blur';
    payload.blurDataURL = media.blurDataUrl;
  }

  return payload;
}
